import { serialize } from 'cookie';
import { GetServerSidePropsContext } from 'next';

import { LWTDate } from '@/valueObjects/date';

export const deleteCookie = (name: string, context?: GetServerSidePropsContext): void => {
  if (context === undefined) deleteCookieClientSide(name);
  else deleteCookieServerSide(name, context);
};

export const getCookie = (name: string, context?: GetServerSidePropsContext): string | undefined =>
  getCookieByName(global.window ? document.cookie : context?.req.headers.cookie, name);

export const setCookie = (name: string, value: string, expires: LWTDate, context?: GetServerSidePropsContext): void => {
  if (context === undefined) setCookieClientSide(name, value, expires);
  else setCookieServerSide(name, value, expires, context);
};

/**
 * @private
 */
const deleteCookieClientSide = (name: string): void => {
  setCookieClientSide(name, '', new LWTDate(0));
};

/**
 * @private
 */
const deleteCookieServerSide = (name: string, context: GetServerSidePropsContext): void => {
  setCookieServerSide(name, '', new LWTDate(0), context);
};

/**
 * @private
 */
const getCookieByName = (cookie: string | undefined, name: string) => {
  return (
    cookie
      ?.split(';')
      .find((splitCookie) => new RegExp(`${name}=.*$`).test(splitCookie))
      ?.split('=')[1] ?? undefined
  );
};

/**
 * @private
 */
const generateCookieString = (name: string, value: string, expires: LWTDate) =>
  `${name}=${value}; Path=/; Expires=${expires.toGMTString()}; SameSite=Strict;`;

/**
 * @private
 */
const setCookieClientSide = (name: string, value: string, expires: LWTDate) => {
  document.cookie = generateCookieString(name, value, expires);
};

/**
 * @private
 */
const setCookieServerSide = (name: string, value: string, expires: LWTDate, context: GetServerSidePropsContext) => {
  context.res.setHeader(
    'Set-Cookie',
    serialize(name, value, {
      path: '/',
      sameSite: true,
      expires,
    }),
  );
};
